/* eslint-disable no-console */
import { Flags } from 'enums';

function getTargeting(owner) {
    const targetingKeys = owner.getTargetingKeys();
    const targeting = targetingKeys.reduce((acc, key) => {
        const val = owner.getTargeting(key);
        acc[key] = val.length === 1 ? val[0] : val;
        return acc;
    }, {});
    return targeting;
}

export default (props = {}) => {
    const globalAdsConfig = (window.espn.ads && window.espn.ads.config) || {};
    const globalKvpsMap = globalAdsConfig.kvps.reduce((total, current) => {
        total[current.name] = current.value;
        return total;
    }, {});

    const { ads } = props;
    if (ads) {
        const localAdsConfig = ads.config;
        const combinedKvpsMap = { ...globalKvpsMap, ...localAdsConfig.kvps };
        const combinedKvpsArray = Object.keys(combinedKvpsMap || {}).map((name) => ({
            name,
            value: combinedKvpsMap[name]
        }));

        // Fixes breakpoints not found error
        globalAdsConfig.breakpoints = {
            xl: [1260],
            l: [1024, 1259],
            m: [768, 1023],
            s: [321, 767],
            xs: [0, 320]
        };

        const adConfig = {
            ...globalAdsConfig,
            disableInitialLoad: true,
            kvps: combinedKvpsArray,
            level: localAdsConfig.level
        };

        if (props.flags[Flags.DEBUG_AD] === 'true') {
            adConfig.onSlotRenderEnded = function onSlotRenderEnded(event) {
                const { creativeId, isEmpty, size, slot } = event;
                const divId = slot.getSlotElementId();
                const pageTargeting = getTargeting(window.googletag.pubads());
                const slotTargeting = getTargeting(slot);

                if (!isEmpty && size) {
                    console.info(`[Ad] type('${slot.type}'), creative('${creativeId}', '${size[0]}x${size[1]}'), div('${divId}')`,
                        slotTargeting, pageTargeting, event);
                } else {
                    console.info(`[Ad] type('${slot.type}'), creative('empty'), div('${divId}')`,
                        slotTargeting, pageTargeting, event);
                }
            };
        }

        return adConfig;
    }
    return {};
};



// WEBPACK FOOTER //
// ./app/common/ads/util/getMergedAdConfig.js